import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { WageRateNewAction } from "../actions";
import * as wageRateApi from "../api/wageRate";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherWageRateNew() {
  yield takeLatest(types.WAGE_RATE_ALL_REQUEST, allWageRateWorker);
  yield takeLatest(types.WAGE_RATE_STORE_REQUEST, storeWageRateWorker);
  yield takeLatest(types.WAGE_RATE_NEW_UPDATE_REQUEST, updateWageRateWorker);
  yield takeLatest(types.WAGE_RATE_REMOVE_REQUEST, deleteWageRateWorker);
}

function fetchAll(contactId) {
  return wageRateApi.getAll(contactId);
}

function* allWageRateWorker(action) {
  try {
    const response = yield call(fetchAll, action.contactId);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data.data;
    yield put(WageRateNewAction.getAllSuccess(data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(WageRateNewAction.getAllFailure(error));
  }
}

function storeWageRate(data, contactId) {
  return wageRateApi.create(data, contactId);
}

function* storeWageRateWorker(action) {
  try {
    const response = yield call(storeWageRate, action.data, action.contactId);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(WageRateNewAction.storeSuccess(response.data));
    yield put(WageRateNewAction.getAll(action.contactId));
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error !== undefined
    ) {
      checkErrorMessagesExist(error) &&
        error.response.data.message.forEach(message => {
          toastr.error(" ", message.toString());
        });
      yield put(WageRateNewAction.storeFailure(error.response.data.error));
    } else {
      checkErrorMessagesExist(error) &&
        error.response.data.message.forEach(message => {
          toastr.error(" ", message.toString());
        });
      yield put(
        WageRateNewAction.storeFailure(
          error.response && error.response.data && error.response.data.message
        )
      );
    }
  }
}

function deleteWageRate(id, contactId) {
  return wageRateApi.remove(id, contactId);
}

function updateWageRate(data, contactId, wageRateId) {
  return wageRateApi.update(data, contactId, wageRateId);
}

function* updateWageRateWorker(action) {
  try {
    const response = yield call(
      updateWageRate,
      action.data,
      action.contactId,
      action.wageRateId
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(WageRateNewAction.updateSuccess(response.data));
    yield put(WageRateNewAction.getAll(action.contactId));
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error !== undefined
    ) {
      checkErrorMessagesExist(error) &&
        error.response.data.message.forEach(message => {
          toastr.error(" ", message.toString());
        });
      yield put(WageRateNewAction.updateFailure(error.response.data.error));
    } else {
      checkErrorMessagesExist(error) &&
        error.response.data.message.forEach(message => {
          toastr.error(" ", message.toString());
        });
      yield put(
        WageRateNewAction.updateFailure(
          error.response && error.response.data && error.response.data.message
        )
      );
    }
  }
}

function* deleteWageRateWorker(action) {
  try {
    const response = yield call(
      deleteWageRate,
      action.id,
      action.contactId,
      action.dailyActivityData
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(WageRateNewAction.removeSuccess(response.data));
    yield put(WageRateNewAction.getAll(action.contactId));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(WageRateNewAction.removeFailure(error));
  }
}
